import React from "react";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="M17.506 2.5c.457 0 .827.37.827.828v13.344c0 .457-.38.828-.827.828H2.493a.827.827 0 01-.827-.828V3.328c0-.457.38-.828.827-.828h15.013zm-.84 1.667H3.333v11.666h13.333V4.167zM14.999 12.5v1.667H5V12.5h10zm-5-6.667v5H5v-5h5zm5 3.334v1.666h-3.333V9.167h3.333zM8.333 7.5H6.666v1.667h1.667V7.5zm6.666-1.667V7.5h-3.333V5.833h3.333z"
      ></path>
    </svg>
  );
}

export default Icon;
